<template>
  <div>
    <cursoHeader></cursoHeader>
    <div class="bg-white border border-gray my2">
      <div
        v-for="record in $dados.APOSTILA.records"
        :key="record.ID"
      >
        <h2 class="m1 center">
          {{record.ASSUNTO}}
        </h2>
        <div
          class="h3 px2 justify"
          v-for="record in record.PARAGRAFOS"
          :key="record.ID"
        >
          <p
            class="bold"
            v-show="record.OBJETIVO"
          >
            Objetivo: {{record.OBJETIVO}}
          </p>
          <p>
            {{record.CONTEUDO}}
          </p>
        </div>
      </div>
    </div>
    <menuBotoes></menuBotoes>
  </div>
</template>

<script>
import cursoHeader from '@/custom/cursoHeader'
import menuBotoes from '@/custom/menuBotoes'
var componentDefinition = {
  components: { cursoHeader, menuBotoes },
  route: {
    name: 'APOSTILA',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/apostila',
    meta: {
      title: 'Apostila',
      hidden: true
    }
  }
}
export default componentDefinition
</script>
